import '@jack-henry/jh-ui/components/switch/switch.js';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { TmFormControl } from '../forms';

const tagName = 'tm-jh-switch';

type JhSwitchEvent = CustomEvent<boolean> & { target: { checked: boolean } };
@customElement(tagName)
export class TmSwitch extends TmFormControl<boolean> {
    @property({ type: String })
    public label?: string;

    @property({ type: Boolean })
    public checked = false;

    @property({ type: Boolean })
    public disabled = false;

    @property({ type: String })
    public helperText?: string;

    protected validate(): boolean {
        return this.checked === true || this.checked === false;
    }

    protected render() {
        return html`<jh-switch
            .checked=${this.checked || Boolean(this.value)}
            .disabled=${this.disabled}
            label=${ifDefined(this.label)}
            @jh-change=${(e: JhSwitchEvent) => this.changeEvent(e)}
            .helperText=${ifDefined(this.helperText)}
        ></jh-switch>`;
    }

    private changeEvent(e: JhSwitchEvent) {
        this.changeValue(e.target.checked);
        const changedEvent = new CustomEvent('change', {
            composed: true,
            bubbles: true,
            detail: e.target.checked,
        });
        this.dispatchEvent(changedEvent);
    }

    public static get styles() {
        return css`
            :host {
                line-height: 0;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmSwitch;
    }
}
